import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { Filters, ThemeConfig } from '../../types';

interface SettingsState {
    search: string;
    priorityNumberIcons: boolean;
    themeId: number | null;
    theme: ThemeConfig | null;
    filters: Filters;
}

const loadInitialState = (): SettingsState => {
    const savedPriorityNumberIcons = localStorage.getItem('priority_number_icons');
    const savedThemeId = localStorage.getItem('theme_id');
    const savedTheme = localStorage.getItem('theme');

    return {
        themeId: savedThemeId ? Number(savedThemeId) : null,
        theme: savedTheme ? JSON.parse(savedTheme) : null,
        priorityNumberIcons: savedPriorityNumberIcons ? true : false,
        search: '',
        filters: {},
    };
};

const initialState: SettingsState = loadInitialState();

export const settingsSlice = createSlice({
    name: 'settings',

    initialState,

    reducers: {
        setSearch: (state, action: PayloadAction<string>) => {
            state.search = action.payload;
        },
        setSettings: (state, action: PayloadAction<Partial<SettingsState>>) => {
            return { ...state, ...action.payload };
        },
        setPriorityNumberIcons: (state, action: PayloadAction<boolean>) => {
            state.priorityNumberIcons = action.payload;
            if (action.payload) {
                localStorage.setItem('priority_number_icons', '1');
            } else {
                localStorage.removeItem('priority_number_icons');
            }
        },
        setTheme: (state, action: PayloadAction<{ themeId: number; theme: ThemeConfig }>) => {
            state.themeId = action.payload.themeId;
            state.theme = action.payload.theme;

            localStorage.setItem('theme_id', String(action.payload.themeId));
            localStorage.setItem('theme', JSON.stringify(action.payload.theme));
        },
        setFilters: (state, action: PayloadAction<Filters>) => {
            state.filters = action.payload;
        },
    },
});

export const { setSearch, setSettings, setPriorityNumberIcons, setTheme, setFilters } = settingsSlice.actions;
